<div class="header">
    <h2>{{ 'predefinedPathways.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="predefined-pathways-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'predefinedPathways.error.unavailable' | translate" />
} @else if (pathway(); as pathway) {
    <div class="body">
        <div class="entity-header">
            <div class="entity-identity">
                <h1>{{ pathway.name }}</h1>
                <p-tag [value]="typeLabel(pathway.type)" severity="info" />
            </div>
        </div>

        <div class="section">
            <h2>{{ 'predefinedPathways.fieldset.basic' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'predefinedPathways.form.name' | translate }}</span>
                <span class="value">{{ pathway.name }}</span>
            </div>
            @if (pathway.description) {
                <div class="field">
                    <span class="label">{{ 'predefinedPathways.form.description' | translate }}</span>
                    <span class="value">{{ pathway.description }}</span>
                </div>
            }
            <div class="field">
                <span class="label">{{ 'predefinedPathways.form.type' | translate }}</span>
                <span class="value">{{ typeLabel(pathway.type) }}</span>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'predefinedPathways.fieldset.assignment' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'predefinedPathways.form.schools' | translate }}</span>
                <app-entity-list [ids]="pathway.schoolIds" type="school" emptyKey="predefinedPathways.schools.empty" />
            </div>
            <div class="field">
                <span class="label">{{ 'predefinedPathways.form.organisations' | translate }}</span>
                <app-entity-list [ids]="pathway.organisationIds" type="organisation" emptyKey="predefinedPathways.organisations.empty" />
            </div>
        </div>

        <div class="section">
            <h2>{{ 'predefinedPathways.form.courses' | translate }}</h2>
            <app-entity-list [ids]="pathway.courseIds" type="course" emptyKey="predefinedPathways.courses.empty" />
        </div>

        <div class="section">
            <h2>{{ 'predefinedPathways.fieldset.stats' | translate }}</h2>
            <div class="row">
                <div class="field">
                    <span class="label">{{ 'predefinedPathways.form.users' | translate }}</span>
                    <span class="value">{{ pathway.userIds.length }}</span>
                </div>
                <div class="field">
                    <span class="label">{{ 'predefinedPathways.form.courses' | translate }}</span>
                    <span class="value">{{ pathway.courseIds.length }}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="footer">
        <app-predefined-pathway-delete-button
            [pathwayId]="pathway.id"
            [schoolIds]="pathway.schoolIds"
            [organisationIds]="pathway.organisationIds"
            [saving]="saving()"
            testId="predefined-pathways-view-delete"
        />
        <p-button
            [label]="'predefinedPathways.detail.edit' | translate"
            icon="pi pi-pencil"
            data-test="predefined-pathways-view-edit"
            (onClick)="onEdit(pathway.id)"
        />
    </div>
}
